import type { FetchAgreementsReportResult } from '../../agreements/report/fetch-agreements-report';
import {
    buildMaterialSummaryFilterFromTaskPaneRead,
    buildMaterialSummaryPayloadFromFilter,
} from '../utils/build-material-summary-payload.util';
import type { MaterialSummaryTaskPaneFilterRead } from '../utils/build-material-summary-payload.util';
import type { MaterialSummaryReportFetchDeps } from './material-summary-fetch.deps';
import { defaultMaterialSummaryReportFetchDeps } from './material-summary-fetch.deps';

/**
 * Material Summary reporting target — Get-Material-Summary only (no Excel). Task pane formats and writes.
 */
export async function fetchMaterialSummaryReport(
    accessToken: string,
    read: MaterialSummaryTaskPaneFilterRead,
    deps: MaterialSummaryReportFetchDeps = defaultMaterialSummaryReportFetchDeps
): Promise<FetchAgreementsReportResult> {
    const filter = buildMaterialSummaryFilterFromTaskPaneRead(read);
    const payload = buildMaterialSummaryPayloadFromFilter(filter);
    const result = await deps.fetchMaterialSummaryActivity(accessToken, payload);

    if (result.kind === 'failure') {
        const source = result.source ?? 'http';
        return {
            kind: 'failure',
            message: result.message,
            source,
            ...(result.invalidElementIds !== undefined
                ? { invalidElementIds: result.invalidElementIds }
                : {}),
            ...(result.httpStatus !== undefined ? { httpStatus: result.httpStatus } : {}),
            ...(result.body !== undefined ? { body: result.body } : {}),
            debugErrorTitle: source === 'validation' ? 'Invalid filters' : 'Report fetch failed',
        };
    }

    const { body, records, totalCount, recordCount, httpStatus } = result;
    return {
        kind: 'success',
        records,
        recordCount,
        totalCount,
        body,
        httpStatus,
    };
}
